import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Card } from '@codametrix/ui-components';
const AmplifyDeprecated = ()=>/*#__PURE__*/ _jsxs(Card, {
        className: "content-vacant qa-amplify-deprecated",
        "data-testid": "amplify-deprecated",
        children: [
            /*#__PURE__*/ _jsx("h2", {
                children: /*#__PURE__*/ _jsx("b", {
                    children: "Codametrix Amplify is no longer available through Epic."
                })
            }),
            /*#__PURE__*/ _jsx("h4", {
                children: "Contact your support representative with questions."
            })
        ]
    });
export default AmplifyDeprecated;
